module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Siblingen-1df44351c71d74ab68159bdb632d884c.png";